import { useApi } from 'hooks/useApi';
import { useStoreUtils } from 'hooks/useStoreUtils';
import React, { useEffect, useState } from 'react';
import UserSynthesesTable from 'views/homeCompta/UserSyntheseTable';

const AdminUsersPage = () => {
	const { getAllUsers } = useApi()
	const { state: { user } } = useStoreUtils()
	const [users, setUsers] = useState([])

	useEffect(() => {
		getAllUsers(user.id)
			.then(setUsers)
			.catch(e => console.log(e))
	}, [getAllUsers, user])

	return (
		<UserSynthesesTable users={users} title='Tous les utilisateurs' />
	);
};

export default AdminUsersPage;